import { MedplumClient } from "@medplum/core";


export const fetchCoverageResponseForPatient = async (patientId: any, medplum: MedplumClient) => {
    try {
      // Fetch the most recent CoverageEligibilityResponse for the given patient
      const [eligibilityResponse] = await medplum.searchResources(
        'CoverageEligibilityResponse',
        `_count=20&_offset=0&_sort=-_lastUpdated&_total=accurate&patient=Patient/${patientId}`
      );
  
      if (!eligibilityResponse) {
        return null;
      }
  
      const { outcome, servicedPeriod, insurer } = eligibilityResponse;
      const organizationId = insurer?.reference?.split('/')[1];
  
      if (!organizationId) {
        return null;
      }
  
      // Fetch the organization by its ID 
      const [organization] = await medplum.searchResources(
        'Organization',
       `_count=20&_id=${organizationId}&_offset=0&_sort=-_lastUpdated&_total=accurate`
      );
  
      if (!organization) {
        return null;
      }
  
      const { name } = organization;
  
      return {
        organizationName: name,
        outcome,
        servicedPeriod,
      };
    } catch (error) {
      console.error('Error fetching coverage response:', error);
      throw new Error('Failed to fetch coverage response');
    }
  };
  